<script>
  import { CircleAlert, Images, LoaderCircle } from 'lucide-svelte';

  export let capture = null;
  export let count = 0;
  export let onOpen = () => {};
</script>

{#if capture}
  <button
    type="button"
    class="thumbnail"
    aria-label="Mở ảnh vừa chụp"
    title="Mở thư viện ảnh"
    on:click={onOpen}>
    <img src={capture.url} alt="Ảnh vừa chụp" />
    {#if capture.status === 'uploading'}
      <span class="status"><span class="spin"><LoaderCircle size="15" /></span></span>
    {:else if capture.status === 'error'}
      <span class="status error"><CircleAlert size="15" /></span>
    {/if}
    {#if count > 1}
      <span class="count"><Images size="11" /> {count}</span>
    {/if}
  </button>
{/if}

<style>
  .thumbnail {
    position: relative;
    flex: 0 0 auto;
    width: 2.7rem;
    height: 2.7rem;
    padding: 0.12rem;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.72);
    border-radius: 0.85rem;
    background: rgba(255, 255, 255, 0.12);
    box-shadow: 0 5px 18px rgba(0, 0, 0, 0.3);
    transition: transform 160ms ease;
  }

  .thumbnail:hover {
    transform: translateY(-1px) scale(1.02);
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 0.68rem;
    object-fit: cover;
  }

  .status,
  .count {
    position: absolute;
    display: grid;
    place-items: center;
    min-width: 1.25rem;
    height: 1.25rem;
    padding: 0 0.25rem;
    border-radius: 999px;
    color: white;
    background: rgba(0, 0, 0, 0.75);
    font-size: 0.7rem;
    font-weight: 700;
  }

  .status {
    inset: 50% auto auto 50%;
    transform: translate(-50%, -50%);
  }

  .status.error {
    background: #dc2626;
  }

  .count {
    top: 0.08rem;
    right: 0.08rem;
    display: flex;
    gap: 0.15rem;
    background: rgba(2, 6, 23, 0.78);
  }

  .spin {
    animation: spin 0.9s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (min-width: 768px) {
    .thumbnail {
      width: 3rem;
      height: 3rem;
    }
  }
</style>
